<template>
  <div>
    <ejs-menu :items='menuitems' :fields='menuFields'></ejs-menu>
  </div>
</template>

<script>
  export default {
    name: 'Comp_MenuBar',
    props: ['menuitems'],
    data() {
      return {
        //Menu fields definition
        menuFields: {
          itemId: 'id',
          text: 'text',
          parentId: 'pid',
          url: 'menuurl'
        }
      }
    },
    methods: {

    }
  }
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">
  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */
</style>

<style scoped>
  @import "../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
  @import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";

  body {
    margin-top: 100px;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/Comp_MenuBar.vue